import { FC, ReactElement } from 'react';
import { SfuModels } from '@stream-io/video-react-sdk';

type NetworkQualityBarsProps = {
  quality: SfuModels.ConnectionQuality;
  size?: 'sm' | 'md';
};

const filledBarsMap: Partial<Record<SfuModels.ConnectionQuality, number>> = {
  [SfuModels.ConnectionQuality.EXCELLENT]: 3,
  [SfuModels.ConnectionQuality.GOOD]: 2,
  [SfuModels.ConnectionQuality.POOR]: 1,
};

const barColorMap: Record<number, string> = {
  3: '#4ade80',
  2: '#facc15',
  1: '#f87171',
  0: 'rgba(255,255,255,0.2)',
};

const sizeConfig = {
  sm: { barW: 3, gap: 2, heights: [5, 8, 11] },
  md: { barW: 4, gap: 3, heights: [6, 10, 14] },
};

const NetworkQualityBars: FC<NetworkQualityBarsProps> = ({ quality, size = 'md' }: NetworkQualityBarsProps): ReactElement => {
  const filledBars: number = filledBarsMap[quality] ?? 0;
  const barColor: string = barColorMap[filledBars] ?? 'rgba(255,255,255,0.2)';
  const { barW, gap, heights } = sizeConfig[size];

  return (
    <div
      className="d-flex align-items-end"
      style={{ gap, height: heights[2] }}
      title={SfuModels.ConnectionQuality[quality] ?? 'Unbekannt'}
    >
      {heights.map((height: number, index: number) => (
        <div
          key={index}
          style={{
            width: barW,
            height,
            borderRadius: 2,
            backgroundColor: index < filledBars ? barColor : 'rgba(255,255,255,0.2)',
            transition: 'background-color 0.4s ease',
          }}
        />
      ))}
    </div>
  );
};

export default NetworkQualityBars;